<template>
    <div class="entry-content">
        <template v-if="!assignUserStatus">
            <v-client-table
                v-if="!preloaderVisibility"
                v-model="lessonTemplates"
                :columns="columnsOptions"
                :options="options"
            >
            <div
                slot="edit"
                slot-scope="lesson"
            >
                <BaseCheckBox
                    :id="lesson.row.lessonTemplateId"
                    :selected="selectedLessons"
                    @on-check-box-click="handleCheckBoxClick"
                />
            </div>
            </v-client-table>
            <div
            v-if="preloaderVisibility"
            class="table-skeleton" />
            <PreloaderComponent v-if="preloaderVisibility"/>
            <Paginate
                v-if="pageCount !== 1 && lessonTemplates.length"
                v-model="currentPage"
                :page-count="pageCount"
                :container-class="'pagination'"
                :page-class="'page-item'"
                :prev-text="'<'"
                :next-text="'>'"
                :prev-class="'page-item'"
                :next-class="'page-item'"
                :click-handler="paginationHandler"/>
            <div class="bottom-content" v-if="selectedLessons.length">
                <button class="next-button" @click="onNextButtonClick">Next</button>
            </div>
        </template>
        <template v-else>
            <h2>Student</h2>
            <vueSelect
             v-model="selectedUser" 
             :options="usersList" 
             @search="fetchUsers"
             label="fullName"
            />
            <div class="bottom-content" v-if="selectedUser">
                <button type="button" class="next-button empty-button" @click="handleRedirect">Cancel</button>
                <button class="next-button" @click="handleCreateButton">Create</button>
            </div>
        </template>
	</div>
</template>


<script>
import vueSelect from 'vue-select'
import Paginate from 'vuejs-paginate'

import CheckAPI from '@/api'
import BaseCheckBox from '@/components/common/BaseCheckBox'
import PreloaderComponent from '@/components/common/PreloaderComponent'

export const tableOptions = {
	resizableColumns: false,
	perPage: 1000,
	perPageValues: [],
	filterable: false,
	highlightMatches: false,
	filterByColumn: false,
	sortable: [],
	skin: '',
	hiddenColumns: ['id'],
	headings: {
		delete: false,
		edit: false
	}
};

export default {
	name: "LessonTemplatePage",
    components: {
        PreloaderComponent,
        Paginate,
        BaseCheckBox,
        vueSelect
    },
    data() {
		return {
            columnsOptions: ['name', 'edit'],
            lessonsTemplates: [],
            lessonTemplates: [],
            options: tableOptions,
            pageCount: 0,
            total: 0,
            currentPage: 1,
            size: 1000,
            preloaderVisibility: true,
            selectedLessons: [],
            assignUserStatus: false,


            selectedUser: '',
            usersList: []
        }
    },
    mounted() {
		this.setInitialPage();
        this.fetchUsers('');
    },
    beforeDestroy() {
        this.$emit('test', false)
    },
    methods: {
        async fetchLessonTemplates() {
            const response = await CheckAPI.getLessonTemplates(
				this.currentPage - 1,
				this.size,
				this.$route.params.courseId
			);
            this.total = response.data.data.total_items
			this.pageCount = response.data.data.total_pages
            this.lessonTemplates = response.data.data.items
            const allLessons = response.data.data.items.map(singleLesson => singleLesson.lessonTemplateId);
            this.selectedLessons = allLessons
            this.preloaderVisibility = false
        },
        setPage() {
			this.currentPage = parseInt(this.$route.query.page || 1);
			this.$router.push({path: this.$route.path, query: { page: parseInt(this.$route.query.page || 1) }})
			this.fetchLessonTemplates();
		},
		setInitialPage() {
			if (this.$route.query.page !== 1) {
				this.currentPage = parseInt(this.$route.query.page || 1);
				this.$router.push({path: this.$route.path, query: { page: parseInt(this.$route.query.page || 1) }})
				this.fetchLessonTemplates();
			}
		},
		paginationHandler(e) {
			this.currentPage = e;
			this.$router.push({path: this.$route.path, query: { page: e }})
			this.preloaderVisibility = true
			this.fetchLessonTemplates();
		},
        handleCheckBoxClick(id) {
            if (this.selectedLessons.includes(id)) {
                const index = this.selectedLessons.indexOf(id);
                this.selectedLessons.splice(index, 1);
            } else {
                this.selectedLessons.push(id)
            }
        },
        onNextButtonClick() {
            this.assignUserStatus = true;
            this.$emit('test', true);
        },
        async fetchUsers(search) {
            const response = await CheckAPI.getAssignableUsers(search);
            const transformedUsers = response.data.data.items.map(singleUser => ({
                ...singleUser,
                fullName: `${singleUser.firstName} ${singleUser.lastName} ${singleUser.email}`
            }))
            this.usersList = transformedUsers
        },
        handleRedirect() {
            this.$router.push('/courses?page=1')
        },
        async handleCreateButton() {
            await CheckAPI.handleCourseAssign({
                courseTemplateId: this.$route.params.courseId,
                lessonIds: this.selectedLessons,
                studentId: this.selectedUser.userId
            })
            this.handleRedirect()
        }
    },
    watch: {
		'$route.query.page': {
			deep: true,
			handler() {
				this.preloaderVisibility = true;
				this.setPage();
			}
		}
	}
}
</script>

<style scoped lang="scss">
.table-heading {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
}

.bottom-content {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-top: 30px;

    .next-button {

        &.empty-button {
            background-color: transparent;
            border: .0625em solid #141638;
            color: #141638;
            margin-right: 15px;
        }
        cursor: pointer;
        background-color: #08ce97;
        border-style: none;
        color: #fff;
        outline: none;
        height: 30px;
        padding-right: 2em;
        padding-left: 2em;
        border-radius: 0.75em;
    }
}

.pagination {
	list-style: none;
	display: flex;
	justify-content: center;
	padding: 0;

	.page-item {
		transition: .4s ease all;
		background-color: #34558b;

		a {
			display: inline-block;
			padding: 6px 10px;
			color: white;
			border-radius: 6px;
		}

		&.active {
			background-color: #35495e;
		}

		&.disabled {
			a {
				color: #35495e;
				cursor: not-allowed;
			}

			&:hover {
				background-color: #fff;
			}

			background-color: #fff;
		}

		margin: 3px;
		border-radius: 6px;

		&:hover {
			a {
				color: white;
			}

			background-color: #35495e;
		}
	}
}

.table-skeleton {
  height: 492px;
}


</style>